import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Alert, Badge, Button, Card, Col, Form, Modal, Row, Spinner, Table } from "react-bootstrap";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import BlockIcon from "@mui/icons-material/Block";
import HistoryIcon from "@mui/icons-material/History";
import DataTableLayout from "layouts/DatatableLayout";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useAppDispatch } from "../../redux/store/configureStore";
import { getStockCountRounds, createStockCountRound, transitionStockCountRound, deleteStockCountRound, getStockCountItems, getStockCountBrands, getStockCountProducts, addStockCountItem, reduceStockCountItem, cancelStockCountItem, getStockCountLogs, exportStockCountExcel } from "../../redux/handlers/stockCount/stockCount.handler";
import { stockCountError } from "utils/stockCountError";
import "styles/stockCount.css";
var statuses = {
    1: "รอดำเนินการ",
    2: "กำลังตรวจนับ",
    3: "สิ้นสุด"
};
// API ใช้ YYYY-MM-DD; แปลงด้วยวันที่ท้องถิ่นเพื่อไม่ให้วันเลื่อนจาก timezone
var pickerDate = function(value) {
    return value ? new Date("".concat(value, "T00:00:00")) : null;
};
var dateValue = function(date) {
    return date ? "".concat(date.getFullYear(), "-").concat(String(date.getMonth() + 1).padStart(2, "0"), "-").concat(String(date.getDate()).padStart(2, "0")) : "";
};
var colors = {
    1: "secondary",
    2: "warning",
    3: "success",
    4: "danger"
};
var stamp = function(value) {
    return value ? new Intl.DateTimeFormat("th-TH", {
        timeZone: "Asia/Bangkok",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
    }).format(new Date(value)) : "-";
};
var integer = function(value) {
    return value !== "" && Number.isInteger(Number(value)) && Number(value) >= 0 && Number(value) <= 2147483647;
};
function PageHeading(param) {
    var title = param.title, children = param.children;
    return /*#__PURE__*/ _jsxs("div", {
        className: "mb-3",
        children: [
            /*#__PURE__*/ _jsx("nav", {
                "aria-label": "breadcrumb",
                children: /*#__PURE__*/ _jsxs("ol", {
                    className: "breadcrumb",
                    children: [
                        /*#__PURE__*/ _jsx("li", {
                            className: "breadcrumb-item",
                            children: /*#__PURE__*/ _jsx(Link, {
                                to: "/",
                                className: "tc-7 text-decoration-none",
                                children: "หน้าหลัก"
                            })
                        }),
                        /*#__PURE__*/ _jsx("li", {
                            className: "breadcrumb-item",
                            children: /*#__PURE__*/ _jsx(Link, {
                                to: "/manage/stock-count",
                                className: "tc-7 text-decoration-none",
                                children: "นับสต๊อคสินค้า"
                            })
                        }),
                        /*#__PURE__*/ _jsx("li", {
                            className: "breadcrumb-item active",
                            children: title
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "d-flex justify-content-between align-items-center flex-wrap gap-2",
                children: [
                    /*#__PURE__*/ _jsx("h1", {
                        className: "fs-24 mb-0",
                        children: title
                    }),
                    children
                ]
            })
        ]
    });
}
function Pager(param) {
    var paging = param.paging, page = param.page, pageSize = param.pageSize, onPage = param.onPage, onSize = param.onSize, loading = param.loading;
    return /*#__PURE__*/ _jsxs("div", {
        className: "d-flex justify-content-end align-items-center flex-wrap gap-3 p-3 border-top",
        children: [
            /*#__PURE__*/ _jsxs("span", {
                children: [
                    paging.total || 0,
                    " รายการ"
                ]
            }),
            /*#__PURE__*/ _jsx(Form.Select, {
                className: "form-st-4 stock-count-page-size",
                "aria-label": "จำนวนรายการต่อหน้า",
                value: pageSize,
                disabled: loading,
                onChange: function(event) {
                    return onSize(Number(event.target.value));
                },
                children: [
                    10,
                    20,
                    50,
                    100
                ].map(function(size) {
                    return /*#__PURE__*/ _jsxs("option", {
                        value: size,
                        children: [
                            size,
                            " รายการ"
                        ]
                    }, size);
                })
            }),
            /*#__PURE__*/ _jsx(Button, {
                variant: "outline-secondary",
                disabled: loading || page <= 1,
                onClick: function() {
                    return onPage(page - 1);
                },
                children: "ก่อนหน้า"
            }),
            /*#__PURE__*/ _jsxs("span", {
                children: [
                    page,
                    " / ",
                    paging.totalPages || 1
                ]
            }),
            /*#__PURE__*/ _jsx(Button, {
                variant: "outline-secondary",
                disabled: loading || page >= (paging.totalPages || 1),
                onClick: function() {
                    return onPage(page + 1);
                },
                children: "ถัดไป"
            })
        ]
    });
}
function IconButton(param) {
    var title = param.title, onClick = param.onClick, children = param.children, _param_danger = param.danger, danger = _param_danger === void 0 ? false : _param_danger, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled;
    return /*#__PURE__*/ _jsx("button", {
        type: "button",
        title: title,
        "aria-label": title,
        onClick: onClick,
        disabled: disabled,
        className: "stock-count-icon ".concat(danger ? "stock-count-icon-danger" : ""),
        children: children
    });
}
function ProductName(param) {
    var product = param.product, _param_snapshot = param.snapshot, snapshot = _param_snapshot === void 0 ? false : _param_snapshot;
    var prefix = snapshot ? "sc_item" : "pd_product";
    return /*#__PURE__*/ _jsxs("div", {
        className: "py-2 stock-count-product-name",
        children: [
            /*#__PURE__*/ _jsx("strong", {
                children: product["".concat(prefix, "_nameth")] || "-"
            }),
            /*#__PURE__*/ _jsx("div", {
                children: product["".concat(prefix, "_nameen")] || "-"
            }),
            /*#__PURE__*/ _jsx("div", {
                children: product["".concat(prefix, "_namela")] || "-"
            }),
            /*#__PURE__*/ _jsxs("small", {
                className: "text-muted",
                children: [
                    "รหัสสินค้า: ",
                    product["".concat(prefix, "_code")] || "-"
                ]
            })
        ]
    });
}
function ProductImage(param) {
    var src = param.src;
    return src ? /*#__PURE__*/ _jsx("img", {
        src: src,
        alt: "รูปสินค้า",
        className: "stock-count-image",
        onError: function(event) {
            event.currentTarget.style.display = "none";
        }
    }) : /*#__PURE__*/ _jsx("span", {
        className: "text-muted",
        children: "ไม่มีรูป"
    });
}
function DetailLines(param) {
    var details = param.details, field = param.field, render = param.render;
    return /*#__PURE__*/ _jsx("div", {
        className: "stock-count-detail-lines",
        children: details.map(function(detail) /*#__PURE__*/ {
            var _detail_field;
            return _jsx("div", {
                className: "stock-count-detail-line",
                children: render ? render(detail) : (_detail_field = detail[field]) !== null && _detail_field !== void 0 ? _detail_field : "-"
            }, detail.sc_detail_id);
        })
    });
}
var unitLabel = function(detail) {
    var snapshot = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var _detail_SetUnit;
    var _detail_sc_detail_ratio, _detail_pd_pdetail_ratio;
    return snapshot ? "".concat(detail.sc_detail_unitname || "-", " (").concat((_detail_sc_detail_ratio = detail.sc_detail_ratio) !== null && _detail_sc_detail_ratio !== void 0 ? _detail_sc_detail_ratio : "-", ")").concat(detail.sc_detail_container ? " ".concat(detail.sc_detail_container) : "") : "".concat(((_detail_SetUnit = detail.SetUnit) === null || _detail_SetUnit === void 0 ? void 0 : _detail_SetUnit.set_unit_name) || "-", " (").concat((_detail_pd_pdetail_ratio = detail.pd_pdetail_ratio) !== null && _detail_pd_pdetail_ratio !== void 0 ? _detail_pd_pdetail_ratio : "-", ")").concat(detail.pd_pdetail_continer ? " ".concat(detail.pd_pdetail_continer) : "");
};
export function StockCountList() {
    var dispatch = useAppDispatch();
    var defaults = {
        search: "",
        dateField: "created",
        startDate: "",
        endDate: "",
        status: ""
    };
    var _useState = _sliced_to_array(useState(defaults), 2), draft = _useState[0], setDraft = _useState[1];
    var _useState1 = _sliced_to_array(useState(_object_spread_props(_object_spread({}, defaults), {
        page: 1,
        pageSize: 20
    })), 2), query = _useState1[0], setQuery = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), rows = _useState2[0], setRows = _useState2[1];
    var _useState3 = _sliced_to_array(useState({}), 2), paging = _useState3[0], setPaging = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), loading = _useState4[0], setLoading = _useState4[1];
    var _useState5 = _sliced_to_array(useState(false), 2), saving = _useState5[0], setSaving = _useState5[1];
    var _useState6 = _sliced_to_array(useState(null), 2), message = _useState6[0], setMessage = _useState6[1];
    var _useState7 = _sliced_to_array(useState(null), 2), dialog = _useState7[0], setDialog = _useState7[1];
    var _useState8 = _sliced_to_array(useState(""), 2), name = _useState8[0], setName = _useState8[1];
    var _useState9 = _sliced_to_array(useState(""), 2), dialogError = _useState9[0], setDialogError = _useState9[1];
    var sequence = useRef(0);
    var load = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var requestId, result, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    requestId = ++sequence.current;
                    setLoading(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4,
                        dispatch(getStockCountRounds(query)).unwrap()
                    ];
                case 2:
                    result = _state.sent();
                    if (requestId !== sequence.current) return [
                        2
                    ];
                    setRows(result.data);
                    setPaging(result.pagination);
                    return [
                        3,
                        5
                    ];
                case 3:
                    error = _state.sent();
                    if (requestId === sequence.current) setMessage({
                        type: "danger",
                        text: stockCountError(error)
                    });
                    return [
                        3,
                        5
                    ];
                case 4:
                    if (requestId === sequence.current) setLoading(false);
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    }), [
        dispatch,
        query
    ]);
    useEffect(function() {
        load();
        return function() {
            sequence.current += 1;
        };
    }, [
        load
    ]);
    var change = function(field) {
        return function(event) {
            return setDraft(function(prev) {
                return _object_spread_props(_object_spread({}, prev), _define_property({}, field, event.target.value));
            });
        };
    };
    var open = function(value) {
        setDialog(value);
        setDialogError("");
        setName("");
    };
    var search = function() {
        if (draft.startDate && draft.endDate && draft.startDate > draft.endDate) {
            setMessage({
                type: "danger",
                text: "วันที่เริ่มต้นต้องไม่เกินวันที่สิ้นสุด"
            });
            return;
        }
        setMessage(null);
        setQuery(_object_spread_props(_object_spread({}, draft), {
            search: draft.search.trim(),
            page: 1,
            pageSize: query.pageSize
        }));
    };
    var save = function() {
        var _ref = _async_to_generator(function() {
            var error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setSaving(true);
                        setDialogError("");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            9,
                            10,
                            11
                        ]);
                        if (!(dialog.type === "create")) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            dispatch(createStockCountRound({
                                name: name.trim()
                            })).unwrap()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 3:
                        if (!(dialog.type === "delete")) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            dispatch(deleteStockCountRound({
                                roundId: dialog.row.sc_round_id
                            })).unwrap()
                        ];
                    case 4:
                        _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 5:
                        return [
                            4,
                            dispatch(transitionStockCountRound({
                                roundId: dialog.row.sc_round_id,
                                status: dialog.row.sc_round_status + 1
                            })).unwrap()
                        ];
                    case 6:
                        _state.sent();
                        _state.label = 7;
                    case 7:
                        setDialog(null);
                        setMessage({
                            type: "success",
                            text: "บันทึกข้อมูลเรียบร้อยแล้ว"
                        });
                        return [
                            4,
                            load()
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            11
                        ];
                    case 9:
                        error = _state.sent();
                        setDialogError(stockCountError(error));
                        return [
                            3,
                            11
                        ];
                    case 10:
                        setSaving(false);
                        return [
                            7
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        });
        return function save() {
            return _ref.apply(this, arguments);
        };
    }();
    var columns = [
        {
            name: "ชื่อรอบ",
            selector: function(row) {
                return row.sc_round_name;
            },
            grow: 2,
            wrap: true
        },
        {
            name: "วันที่สร้าง",
            selector: function(row) {
                return stamp(row.sc_round_credate);
            },
            minWidth: "170px"
        },
        {
            name: "วันที่เริ่ม",
            selector: function(row) {
                return stamp(row.sc_round_startdate);
            },
            minWidth: "170px"
        },
        {
            name: "วันที่สิ้นสุด",
            selector: function(row) {
                return stamp(row.sc_round_enddate);
            },
            minWidth: "170px"
        },
        {
            name: "สถานะ",
            minWidth: "160px",
            cell: function(row) {
                return [
                    1,
                    2
                ].includes(row.sc_round_status) ? /*#__PURE__*/ _jsx(Button, {
                    size: "sm",
                    variant: colors[row.sc_round_status],
                    disabled: saving || loading,
                    onClick: function() {
                        return open({
                            type: "transition",
                            row: row
                        });
                    },
                    children: statuses[row.sc_round_status]
                }) : /*#__PURE__*/ _jsx(Badge, {
                    bg: colors[row.sc_round_status],
                    children: statuses[row.sc_round_status]
                });
            }
        },
        {
            name: "จัดการ",
            width: "120px",
            cell: function(row) {
                return /*#__PURE__*/ _jsxs("div", {
                    className: "d-flex gap-2",
                    children: [
                        /*#__PURE__*/ _jsx(Link, {
                            className: "stock-count-icon",
                            title: "แก้ไข / ดูข้อมูล",
                            "aria-label": "แก้ไข / ดูข้อมูล",
                            to: "/manage/stock-count/".concat(row.sc_round_id),
                            children: /*#__PURE__*/ _jsx(EditIcon, {
                                fontSize: "small"
                            })
                        }),
                        row.sc_round_status === 1 && /*#__PURE__*/ _jsx(IconButton, {
                            danger: true,
                            title: "ลบรอบ",
                            disabled: saving || loading,
                            onClick: function() {
                                return open({
                                    type: "delete",
                                    row: row
                                });
                            },
                            children: /*#__PURE__*/ _jsx(DeleteOutlineIcon, {
                                fontSize: "small"
                            })
                        })
                    ]
                });
            }
        }
    ];
    return /*#__PURE__*/ _jsxs("div", {
        className: "stock-count",
        children: [
            /*#__PURE__*/ _jsx(PageHeading, {
                title: "รอบนับสต๊อคสินค้า",
                children: /*#__PURE__*/ _jsx(Button, {
                    className: "btn-dg",
                    onClick: function() {
                        return open({
                            type: "create"
                        });
                    },
                    children: "สร้างรอบ"
                })
            }),
            message && /*#__PURE__*/ _jsx(Alert, {
                variant: message.type,
                dismissible: true,
                onClose: function() {
                    return setMessage(null);
                },
                children: message.text
            }),
            /*#__PURE__*/ _jsxs(Card, {
                children: [
                    /*#__PURE__*/ _jsx(Card.Body, {
                        children: /*#__PURE__*/ _jsxs(Row, {
                            className: "g-3 align-items-end",
                            children: [
                                /*#__PURE__*/ _jsx(Col, {
                                    md: 4,
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "form-st-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                children: "ค้นหาชื่อรอบ"
                                            }),
                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                className: "form-st-4",
                                                value: draft.search,
                                                onChange: change("search"),
                                                placeholder: "ชื่อรอบตรวจนับ"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    md: 2,
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "form-st-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                children: "ประเภทวันที่"
                                            }),
                                            /*#__PURE__*/ _jsxs(Form.Select, {
                                                className: "form-st-4",
                                                value: draft.dateField,
                                                onChange: change("dateField"),
                                                children: [
                                                    /*#__PURE__*/ _jsx("option", {
                                                        value: "created",
                                                        children: "วันที่สร้าง"
                                                    }),
                                                    /*#__PURE__*/ _jsx("option", {
                                                        value: "started",
                                                        children: "วันที่เริ่ม"
                                                    }),
                                                    /*#__PURE__*/ _jsx("option", {
                                                        value: "ended",
                                                        children: "วันที่สิ้นสุด"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    md: 3,
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "form-st-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                htmlFor: "stock-count-start-date",
                                                children: "วันที่เริ่มต้นค้นหา"
                                            }),
                                            /*#__PURE__*/ _jsx(DatePicker, {
                                                id: "stock-count-start-date",
                                                className: "form-st-4 w-100 datepicker2",
                                                dateFormat: "dd/MM/yyyy",
                                                placeholderText: "วันที่เริ่มต้นค้นหา",
                                                selected: pickerDate(draft.startDate),
                                                onChange: function(date) {
                                                    return setDraft(function(prev) {
                                                        return _object_spread_props(_object_spread({}, prev), {
                                                            startDate: dateValue(date)
                                                        });
                                                    });
                                                },
                                                isClearable: true
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    md: 3,
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "form-st-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                htmlFor: "stock-count-end-date",
                                                children: "วันที่สิ้นสุดค้นหา"
                                            }),
                                            /*#__PURE__*/ _jsx(DatePicker, {
                                                id: "stock-count-end-date",
                                                className: "form-st-4 w-100 datepicker2",
                                                dateFormat: "dd/MM/yyyy",
                                                placeholderText: "วันที่สิ้นสุดค้นหา",
                                                selected: pickerDate(draft.endDate),
                                                onChange: function(date) {
                                                    return setDraft(function(prev) {
                                                        return _object_spread_props(_object_spread({}, prev), {
                                                            endDate: dateValue(date)
                                                        });
                                                    });
                                                },
                                                isClearable: true
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    md: 3,
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "form-st-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                children: "สถานะ"
                                            }),
                                            /*#__PURE__*/ _jsxs(Form.Select, {
                                                className: "form-st-4",
                                                value: draft.status,
                                                onChange: change("status"),
                                                children: [
                                                    /*#__PURE__*/ _jsx("option", {
                                                        value: "",
                                                        children: "ทั้งหมด"
                                                    }),
                                                    Object.entries(statuses).map(function(param) {
                                                        var _param = _sliced_to_array(param, 2), value = _param[0], label = _param[1];
                                                        return /*#__PURE__*/ _jsx("option", {
                                                            value: value,
                                                            children: label
                                                        }, value);
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    className: "text-end",
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        className: "btn-dg px-4",
                                        disabled: loading,
                                        onClick: search,
                                        children: "ค้นหา"
                                    })
                                })
                            ]
                        })
                    }),
                    loading && /*#__PURE__*/ _jsxs("div", {
                        className: "p-3",
                        role: "status",
                        children: [
                            /*#__PURE__*/ _jsx(Spinner, {
                                size: "sm"
                            }),
                            " กำลังโหลดข้อมูล..."
                        ]
                    }),
                    /*#__PURE__*/ _jsx(DataTableLayout, {
                        item: rows,
                        columns: columns,
                        keyField: "sc_round_id",
                        isSelectRows: false,
                        pagination: false
                    }),
                    /*#__PURE__*/ _jsx(Pager, {
                        paging: paging,
                        page: query.page,
                        pageSize: query.pageSize,
                        loading: loading,
                        onPage: function(page) {
                            return setQuery(_object_spread_props(_object_spread({}, query), {
                                page: page
                            }));
                        },
                        onSize: function(pageSize) {
                            return setQuery(_object_spread_props(_object_spread({}, query), {
                                pageSize: pageSize,
                                page: 1
                            }));
                        }
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Modal, {
                className: "stock-count",
                show: !!dialog,
                onHide: function() {
                    return !saving && setDialog(null);
                },
                centered: true,
                backdrop: "static",
                children: [
                    /*#__PURE__*/ _jsx(Modal.Header, {
                        closeButton: !saving,
                        children: /*#__PURE__*/ _jsx(Modal.Title, {
                            children: (dialog === null || dialog === void 0 ? void 0 : dialog.type) === "create" ? "สร้างรอบตรวจนับ" : (dialog === null || dialog === void 0 ? void 0 : dialog.type) === "delete" ? "ยืนยันลบรอบ" : "ยืนยันเปลี่ยนสถานะ"
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Modal.Body, {
                        children: [
                            dialogError && /*#__PURE__*/ _jsx(Alert, {
                                variant: "danger",
                                children: dialogError
                            }),
                            (dialog === null || dialog === void 0 ? void 0 : dialog.type) === "create" ? /*#__PURE__*/ _jsx(_Fragment, {
                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                    className: "form-st-3",
                                    children: [
                                        /*#__PURE__*/ _jsx(Form.Label, {
                                            children: "ชื่อรอบ"
                                        }),
                                        /*#__PURE__*/ _jsx(Form.Control, {
                                            className: "form-st-4",
                                            autoFocus: true,
                                            maxLength: 200,
                                            value: name,
                                            onChange: function(event) {
                                                return setName(event.target.value);
                                            }
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ _jsxs("p", {
                                children: [
                                    "ยืนยัน",
                                    (dialog === null || dialog === void 0 ? void 0 : dialog.type) === "delete" ? "ลบรอบ" : (dialog === null || dialog === void 0 ? void 0 : dialog.row.sc_round_status) === 1 ? "เริ่มตรวจนับรอบ" : "สิ้นสุดรอบ",
                                    " ",
                                    "“",
                                    dialog === null || dialog === void 0 ? void 0 : dialog.row.sc_round_name,
                                    "” หรือไม่?"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Modal.Footer, {
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                variant: "secondary",
                                disabled: saving,
                                onClick: function() {
                                    return setDialog(null);
                                },
                                children: "ปิด"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                className: "btn-dg",
                                disabled: saving || (dialog === null || dialog === void 0 ? void 0 : dialog.type) === "create" && !name.trim(),
                                onClick: save,
                                children: saving ? "กำลังบันทึก..." : "ยืนยัน"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
export function StockCountEdit() {
    var _useState = _sliced_to_array(useState(false), 2), exporting = _useState[0], setExporting = _useState[1];
    var dispatch = useAppDispatch();
    var roundId = useParams().roundId;
    var _useState1 = _sliced_to_array(useState(null), 2), round = _useState1[0], setRound = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), rows = _useState2[0], setRows = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), brands = _useState3[0], setBrands = _useState3[1];
    var _useState4 = _sliced_to_array(useState({
        search: "",
        brandId: ""
    }), 2), draft = _useState4[0], setDraft = _useState4[1];
    var _useState5 = _sliced_to_array(useState({
        search: "",
        brandId: "",
        page: 1,
        pageSize: 20
    }), 2), query = _useState5[0], setQuery = _useState5[1];
    var _useState6 = _sliced_to_array(useState({}), 2), paging = _useState6[0], setPaging = _useState6[1];
    var _useState7 = _sliced_to_array(useState(false), 2), loading = _useState7[0], setLoading = _useState7[1];
    var _useState8 = _sliced_to_array(useState(false), 2), saving = _useState8[0], setSaving = _useState8[1];
    var _useState9 = _sliced_to_array(useState(null), 2), message = _useState9[0], setMessage = _useState9[1];
    var _useState10 = _sliced_to_array(useState(null), 2), editing = _useState10[0], setEditing = _useState10[1];
    var _useState11 = _sliced_to_array(useState({}), 2), amounts = _useState11[0], setAmounts = _useState11[1];
    var _useState12 = _sliced_to_array(useState(""), 2), remark = _useState12[0], setRemark = _useState12[1];
    var _useState13 = _sliced_to_array(useState(""), 2), dialogError = _useState13[0], setDialogError = _useState13[1];
    var _useState14 = _sliced_to_array(useState(false), 2), picker = _useState14[0], setPicker = _useState14[1];
    var _useState15 = _sliced_to_array(useState(null), 2), logData = _useState15[0], setLogData = _useState15[1];
    var sequence = useRef(0);
    var editable = (round === null || round === void 0 ? void 0 : round.sc_round_status) === 2;
    var handleExport = function() {
        var _ref = _async_to_generator(function() {
            var error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setExporting(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            dispatch(exportStockCountExcel({
                                roundId: roundId
                            })).unwrap()
                        ];
                    case 2:
                        _state.sent();
                        setMessage({
                            type: "success",
                            text: "Export Excel สำเร็จ"
                        });
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        setMessage({
                            type: "danger",
                            text: stockCountError(error)
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setExporting(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleExport() {
            return _ref.apply(this, arguments);
        };
    }();
    var load = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var requestId, result, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    requestId = ++sequence.current;
                    setLoading(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4,
                        dispatch(getStockCountItems(_object_spread_props(_object_spread({}, query), {
                            roundId: roundId
                        }))).unwrap()
                    ];
                case 2:
                    result = _state.sent();
                    if (requestId !== sequence.current) return [
                        2
                    ];
                    setRound(result.round);
                    setRows(result.data);
                    setPaging(result.pagination);
                    return [
                        3,
                        5
                    ];
                case 3:
                    error = _state.sent();
                    if (requestId === sequence.current) {
                        setRound(null);
                        setMessage({
                            type: "danger",
                            text: stockCountError(error)
                        });
                    }
                    return [
                        3,
                        5
                    ];
                case 4:
                    if (requestId === sequence.current) setLoading(false);
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    }), [
        dispatch,
        query,
        roundId
    ]);
    useEffect(function() {
        load();
        return function() {
            sequence.current += 1;
        };
    }, [
        load
    ]);
    useEffect(function() {
        var active = true;
        dispatch(getStockCountBrands()).unwrap().then(function(data) {
            if (active) setBrands(data);
        }).catch(function(error) {
            if (active) setMessage({
                type: "danger",
                text: stockCountError(error)
            });
        });
        return function() {
            active = false;
        };
    }, [
        dispatch
    ]);
    var openEdit = function(row, type) {
        setEditing({
            row: row,
            type: type
        });
        setDialogError("");
        setRemark("");
        setAmounts(Object.fromEntries(row.details.map(function(detail) {
            return [
                detail.sc_detail_id,
                String(detail.sc_detail_amount)
            ];
        })));
    };
    var save = function() {
        var _ref = _async_to_generator(function() {
            var error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setSaving(true);
                        setDialogError("");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            9
                        ]);
                        if (!(editing.type === "cancel")) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            dispatch(cancelStockCountItem({
                                roundId: roundId,
                                itemId: editing.row.sc_item_id,
                                remark: remark.trim()
                            })).unwrap()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            dispatch(reduceStockCountItem({
                                roundId: roundId,
                                itemId: editing.row.sc_item_id,
                                details: editing.row.details.map(function(detail) {
                                    return {
                                        detailId: detail.sc_detail_id,
                                        amount: Number(amounts[detail.sc_detail_id]),
                                        before: detail.sc_detail_amount
                                    };
                                })
                            })).unwrap()
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        setEditing(null);
                        setMessage({
                            type: "success",
                            text: "บันทึกข้อมูลเรียบร้อยแล้ว"
                        });
                        return [
                            4,
                            load()
                        ];
                    case 6:
                        _state.sent();
                        return [
                            3,
                            9
                        ];
                    case 7:
                        error = _state.sent();
                        setDialogError(stockCountError(error));
                        return [
                            3,
                            9
                        ];
                    case 8:
                        setSaving(false);
                        return [
                            7
                        ];
                    case 9:
                        return [
                            2
                        ];
                }
            });
        });
        return function save() {
            return _ref.apply(this, arguments);
        };
    }();
    var showLogs = function() {
        var _ref = _async_to_generator(function(row) {
            var logs, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        setLogData({
                            loading: true,
                            row: row,
                            logs: []
                        });
                        return [
                            4,
                            dispatch(getStockCountLogs({
                                itemId: row.sc_item_id
                            })).unwrap()
                        ];
                    case 1:
                        logs = _state.sent();
                        setLogData({
                            row: row,
                            logs: logs
                        });
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        setLogData(null);
                        setMessage({
                            type: "danger",
                            text: stockCountError(error)
                        });
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function showLogs(row) {
            return _ref.apply(this, arguments);
        };
    }();
    var columns = [
        {
            name: "รูปสินค้า",
            width: "100px",
            cell: function(row) {
                return /*#__PURE__*/ _jsx(ProductImage, {
                    src: row.sc_item_image
                });
            }
        },
        {
            name: "ชื่อสินค้า",
            minWidth: "250px",
            grow: 2,
            cell: function(row) {
                return /*#__PURE__*/ _jsx(ProductName, {
                    product: row,
                    snapshot: true
                });
            }
        },
        {
            name: "barcode",
            minWidth: "170px",
            cell: function(row) {
                return /*#__PURE__*/ _jsx(DetailLines, {
                    details: row.details,
                    field: "sc_detail_barcode"
                });
            }
        },
        {
            name: "ขนาดบรรจุ",
            minWidth: "190px",
            cell: function(row) {
                return /*#__PURE__*/ _jsx(DetailLines, {
                    details: row.details,
                    render: function(detail) {
                        return unitLabel(detail);
                    }
                });
            }
        },
        {
            name: "จำนวน",
            minWidth: "110px",
            cell: function(row) {
                return /*#__PURE__*/ _jsx(DetailLines, {
                    details: row.details,
                    render: function(detail) {
                        return /*#__PURE__*/ _jsx("strong", {
                            children: detail.sc_detail_amount.toLocaleString()
                        });
                    }
                });
            }
        },
        {
            name: "ผู้ตรวจนับ",
            minWidth: "180px",
            cell: function(row) {
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        row.creator_name,
                        /*#__PURE__*/ _jsx("small", {
                            className: "d-block text-muted",
                            children: stamp(row.sc_item_credate)
                        })
                    ]
                });
            }
        },
        {
            name: "หมายเหตุ",
            minWidth: "230px",
            cell: function(row) {
                return /*#__PURE__*/ _jsx("div", {
                    className: "py-2",
                    children: row.sc_item_status === 2 && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("strong", {
                                className: "text-danger me-2",
                                children: "ยกเลิก"
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                children: row.sc_item_remark
                            }),
                            /*#__PURE__*/ _jsxs("small", {
                                className: "d-block text-muted",
                                children: [
                                    row.cancel_name || "#".concat(row.sc_item_cancelbyid),
                                    " \xb7",
                                    " ",
                                    stamp(row.sc_item_canceldate)
                                ]
                            })
                        ]
                    })
                });
            }
        },
        {
            name: "จัดการ",
            width: "150px",
            cell: function(row) {
                return /*#__PURE__*/ _jsxs("div", {
                    className: "d-flex gap-2",
                    children: [
                        editable && row.sc_item_status === 1 && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(IconButton, {
                                    title: "ลดจำนวน",
                                    disabled: loading || saving,
                                    onClick: function() {
                                        return openEdit(row, "reduce");
                                    },
                                    children: /*#__PURE__*/ _jsx(EditIcon, {
                                        fontSize: "small"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(IconButton, {
                                    danger: true,
                                    title: "ยกเลิกสินค้า",
                                    disabled: loading || saving,
                                    onClick: function() {
                                        return openEdit(row, "cancel");
                                    },
                                    children: /*#__PURE__*/ _jsx(BlockIcon, {
                                        fontSize: "small"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(IconButton, {
                            title: "ประวัติการลดจำนวน",
                            onClick: function() {
                                return showLogs(row);
                            },
                            children: /*#__PURE__*/ _jsx(HistoryIcon, {
                                fontSize: "small"
                            })
                        })
                    ]
                });
            }
        }
    ];
    var validReduction = (editing === null || editing === void 0 ? void 0 : editing.type) === "reduce" && editing.row.details.every(function(detail) {
        return integer(amounts[detail.sc_detail_id]) && Number(amounts[detail.sc_detail_id]) <= detail.sc_detail_amount;
    }) && editing.row.details.some(function(detail) {
        return Number(amounts[detail.sc_detail_id]) < detail.sc_detail_amount;
    });
    return /*#__PURE__*/ _jsxs("div", {
        className: "stock-count",
        children: [
            /*#__PURE__*/ _jsx(PageHeading, {
                title: (round === null || round === void 0 ? void 0 : round.sc_round_name) || "รายละเอียดรอบตรวจนับ",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "d-flex align-items-center gap-2",
                    children: [
                        round && /*#__PURE__*/ _jsx(Badge, {
                            bg: colors[round.sc_round_status],
                            children: statuses[round.sc_round_status]
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            as: Link,
                            to: "/manage/stock-count",
                            variant: "outline-secondary",
                            children: "กลับรายการ"
                        }),
                        editable && /*#__PURE__*/ _jsx(Button, {
                            className: "btn-dg",
                            disabled: loading,
                            onClick: function() {
                                return setPicker(true);
                            },
                            children: "เลือกสินค้า"
                        }),
                        (round === null || round === void 0 ? void 0 : round.sc_round_status) === 3 && /*#__PURE__*/ _jsx(Button, {
                            className: "btn-export-st-1",
                            variant: "outline-secondary",
                            disabled: loading || exporting,
                            onClick: handleExport,
                            children: exporting ? "กำลัง Export..." : "Export Excel"
                        })
                    ]
                })
            }),
            round && /*#__PURE__*/ _jsxs("div", {
                className: "text-muted mb-3",
                children: [
                    "สร้าง: ",
                    stamp(round.sc_round_credate),
                    " \xb7 เริ่ม:",
                    " ",
                    stamp(round.sc_round_startdate),
                    " \xb7 สิ้นสุด:",
                    " ",
                    stamp(round.sc_round_enddate)
                ]
            }),
            message && /*#__PURE__*/ _jsx(Alert, {
                variant: message.type,
                dismissible: true,
                onClose: function() {
                    return setMessage(null);
                },
                children: message.text
            }),
            round && !editable && /*#__PURE__*/ _jsx(Alert, {
                variant: "secondary",
                children: "รอบนี้ดูข้อมูลได้อย่างเดียว แก้ไขได้เฉพาะสถานะกำลังตรวจนับ"
            }),
            /*#__PURE__*/ _jsxs(Card, {
                children: [
                    /*#__PURE__*/ _jsx(Card.Body, {
                        children: /*#__PURE__*/ _jsxs(Row, {
                            className: "g-3 align-items-end",
                            children: [
                                /*#__PURE__*/ _jsx(Col, {
                                    md: 6,
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "form-st-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                children: "ค้นหาสินค้า"
                                            }),
                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                className: "form-st-4",
                                                value: draft.search,
                                                placeholder: "ชื่อไทย / อังกฤษ / ลาว / รหัสสินค้า / barcode",
                                                onChange: function(event) {
                                                    return setDraft(_object_spread_props(_object_spread({}, draft), {
                                                        search: event.target.value
                                                    }));
                                                }
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    md: 4,
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "form-st-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                children: "แบรนด์"
                                            }),
                                            /*#__PURE__*/ _jsxs(Form.Select, {
                                                className: "form-st-4",
                                                value: draft.brandId,
                                                onChange: function(event) {
                                                    return setDraft(_object_spread_props(_object_spread({}, draft), {
                                                        brandId: event.target.value
                                                    }));
                                                },
                                                children: [
                                                    /*#__PURE__*/ _jsx("option", {
                                                        value: "",
                                                        children: "ทั้งหมด"
                                                    }),
                                                    brands.map(function(brand) {
                                                        return /*#__PURE__*/ _jsx("option", {
                                                            value: brand.set_brand_id,
                                                            children: brand.set_brand_name || brand.set_brand_nameen || "#".concat(brand.set_brand_id)
                                                        }, brand.set_brand_id);
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    md: 2,
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        className: "btn-dg w-100",
                                        disabled: loading,
                                        onClick: function() {
                                            setMessage(null);
                                            setQuery(_object_spread_props(_object_spread({}, query, draft), {
                                                search: draft.search.trim(),
                                                page: 1
                                            }));
                                        },
                                        children: "ค้นหา"
                                    })
                                })
                            ]
                        })
                    }),
                    loading && /*#__PURE__*/ _jsxs("div", {
                        role: "status",
                        className: "p-3",
                        children: [
                            /*#__PURE__*/ _jsx(Spinner, {
                                size: "sm"
                            }),
                            " กำลังโหลดข้อมูล..."
                        ]
                    }),
                    /*#__PURE__*/ _jsx(DataTableLayout, {
                        item: rows,
                        columns: columns,
                        keyField: "sc_item_id",
                        isSelectRows: false,
                        pagination: false
                    }),
                    /*#__PURE__*/ _jsx(Pager, {
                        paging: paging,
                        page: query.page,
                        pageSize: query.pageSize,
                        loading: loading,
                        onPage: function(page) {
                            return setQuery(_object_spread_props(_object_spread({}, query), {
                                page: page
                            }));
                        },
                        onSize: function(pageSize) {
                            return setQuery(_object_spread_props(_object_spread({}, query), {
                                pageSize: pageSize,
                                page: 1
                            }));
                        }
                    })
                ]
            }),
            picker && /*#__PURE__*/ _jsx(ProductPicker, {
                roundId: roundId,
                brands: brands,
                onClose: function() {
                    return setPicker(false);
                },
                onSaved: /*#__PURE__*/ _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                setPicker(false);
                                setMessage({
                                    type: "success",
                                    text: "เพิ่มรายการสินค้าเรียบร้อยแล้ว"
                                });
                                return [
                                    4,
                                    load()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })
            }),
            /*#__PURE__*/ _jsxs(Modal, {
                className: "stock-count",
                show: !!editing,
                onHide: function() {
                    return !saving && setEditing(null);
                },
                centered: true,
                size: "lg",
                backdrop: "static",
                children: [
                    /*#__PURE__*/ _jsx(Modal.Header, {
                        closeButton: !saving,
                        children: /*#__PURE__*/ _jsx(Modal.Title, {
                            children: (editing === null || editing === void 0 ? void 0 : editing.type) === "cancel" ? "ยกเลิกสินค้า" : "ลดจำนวนตรวจนับ"
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Modal.Body, {
                        children: [
                            dialogError && /*#__PURE__*/ _jsx(Alert, {
                                variant: "danger",
                                children: dialogError
                            }),
                            editing && /*#__PURE__*/ _jsx(ProductName, {
                                product: editing.row,
                                snapshot: true
                            }),
                            (editing === null || editing === void 0 ? void 0 : editing.type) === "cancel" ? /*#__PURE__*/ _jsx(_Fragment, {
                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                    className: "form-st-3",
                                    children: [
                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                            htmlFor: "stock-count-cancel-remark",
                                            children: [
                                                "หมายเหตุยกเลิก ",
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "text-danger",
                                                    children: "*"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Form.Control, {
                                            className: "form-st-4",
                                            id: "stock-count-cancel-remark",
                                            as: "textarea",
                                            rows: 3,
                                            maxLength: 2000,
                                            autoFocus: true,
                                            value: remark,
                                            onChange: function(event) {
                                                return setRemark(event.target.value);
                                            }
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "text-muted",
                                        children: "ลดจำนวนอย่างน้อยหนึ่งหน่วย หน่วยอื่นคงจำนวนเดิมได้"
                                    }),
                                    /*#__PURE__*/ _jsxs(Table, {
                                        responsive: true,
                                        children: [
                                            /*#__PURE__*/ _jsx("thead", {
                                                children: /*#__PURE__*/ _jsxs("tr", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "barcode"
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "ขนาดบรรจุ"
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "ก่อนแก้ไข"
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "จำนวนใหม่"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("tbody", {
                                                children: editing === null || editing === void 0 ? void 0 : editing.row.details.map(function(detail) /*#__PURE__*/ {
                                                    var _amounts_detail_sc_detail_id;
                                                    return _jsxs("tr", {
                                                        children: [
                                                            /*#__PURE__*/ _jsx("td", {
                                                                children: detail.sc_detail_barcode || "-"
                                                            }),
                                                            /*#__PURE__*/ _jsx("td", {
                                                                children: unitLabel(detail)
                                                            }),
                                                            /*#__PURE__*/ _jsx("td", {
                                                                children: detail.sc_detail_amount
                                                            }),
                                                            /*#__PURE__*/ _jsx("td", {
                                                                children: /*#__PURE__*/ _jsx(Form.Control, {
                                                                    className: "form-st-4",
                                                                    "aria-label": "จำนวนใหม่ ".concat(unitLabel(detail)),
                                                                    type: "number",
                                                                    min: 0,
                                                                    max: detail.sc_detail_amount,
                                                                    step: 1,
                                                                    value: (_amounts_detail_sc_detail_id = amounts[detail.sc_detail_id]) !== null && _amounts_detail_sc_detail_id !== void 0 ? _amounts_detail_sc_detail_id : "",
                                                                    onChange: function(event) {
                                                                        return setAmounts(_object_spread_props(_object_spread({}, amounts), _define_property({}, detail.sc_detail_id, event.target.value)));
                                                                    }
                                                                })
                                                            })
                                                        ]
                                                    }, detail.sc_detail_id);
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Modal.Footer, {
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                variant: "secondary",
                                disabled: saving,
                                onClick: function() {
                                    return setEditing(null);
                                },
                                children: "ปิด"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                className: "btn-dg",
                                disabled: saving || ((editing === null || editing === void 0 ? void 0 : editing.type) === "cancel" ? !remark.trim() : !validReduction),
                                onClick: save,
                                children: saving ? "กำลังบันทึก..." : "ยืนยัน"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Modal, {
                className: "stock-count",
                show: !!logData,
                onHide: function() {
                    return setLogData(null);
                },
                size: "xl",
                centered: true,
                children: [
                    /*#__PURE__*/ _jsx(Modal.Header, {
                        closeButton: true,
                        children: /*#__PURE__*/ _jsx(Modal.Title, {
                            children: "ประวัติการลดจำนวน"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Modal.Body, {
                        children: (logData === null || logData === void 0 ? void 0 : logData.loading) ? /*#__PURE__*/ _jsx(Spinner, {
                            size: "sm"
                        }) : /*#__PURE__*/ _jsxs(Table, {
                            responsive: true,
                            children: [
                                /*#__PURE__*/ _jsx("thead", {
                                    children: /*#__PURE__*/ _jsxs("tr", {
                                        children: [
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "วันที่แก้ไข"
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "barcode / หน่วย"
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "ก่อน"
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "หลัง"
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "ผู้ใส่ข้อมูลก่อนหน้า"
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "ผู้แก้ไข"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("tbody", {
                                    children: (logData === null || logData === void 0 ? void 0 : logData.logs.length) ? logData.logs.map(function(log) {
                                        return /*#__PURE__*/ _jsxs("tr", {
                                            children: [
                                                /*#__PURE__*/ _jsx("td", {
                                                    children: stamp(log.sc_log_credate)
                                                }),
                                                /*#__PURE__*/ _jsxs("td", {
                                                    children: [
                                                        log.detail.sc_detail_barcode || "-",
                                                        /*#__PURE__*/ _jsx("small", {
                                                            className: "d-block",
                                                            children: unitLabel(log.detail)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    children: log.sc_log_before
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    children: log.sc_log_after
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    children: log.previous_name || "#".concat(log.sc_log_previousbyid)
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    children: log.editor_name || "#".concat(log.sc_log_crebyid)
                                                })
                                            ]
                                        }, log.sc_log_id);
                                    }) : /*#__PURE__*/ _jsx("tr", {
                                        children: /*#__PURE__*/ _jsx("td", {
                                            colSpan: 6,
                                            className: "text-center text-muted",
                                            children: "ยังไม่มีประวัติการลดจำนวน"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
function ProductPicker(param) {
    var roundId = param.roundId, brands = param.brands, onClose = param.onClose, onSaved = param.onSaved;
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState({
        search: "",
        brandId: ""
    }), 2), draft = _useState[0], setDraft = _useState[1];
    var _useState1 = _sliced_to_array(useState({
        search: "",
        brandId: "",
        page: 1,
        pageSize: 10
    }), 2), query = _useState1[0], setQuery = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), rows = _useState2[0], setRows = _useState2[1];
    var _useState3 = _sliced_to_array(useState({}), 2), paging = _useState3[0], setPaging = _useState3[1];
    var _useState4 = _sliced_to_array(useState(null), 2), selected = _useState4[0], setSelected = _useState4[1];
    var _useState5 = _sliced_to_array(useState({}), 2), amounts = _useState5[0], setAmounts = _useState5[1];
    var _useState6 = _sliced_to_array(useState(false), 2), loading = _useState6[0], setLoading = _useState6[1];
    var _useState7 = _sliced_to_array(useState(false), 2), saving = _useState7[0], setSaving = _useState7[1];
    var _useState8 = _sliced_to_array(useState(""), 2), error = _useState8[0], setError = _useState8[1];
    useEffect(function() {
        var active = true;
        setLoading(true);
        dispatch(getStockCountProducts(query)).unwrap().then(function(result) {
            if (active) {
                setRows(result.data);
                setPaging(result.pagination);
            }
        }).catch(function(err) {
            if (active) setError(stockCountError(err));
        }).finally(function() {
            if (active) setLoading(false);
        });
        return function() {
            active = false;
        };
    }, [
        dispatch,
        query
    ]);
    var select = function(product) {
        setSelected(product);
        setError("");
        setAmounts(Object.fromEntries(product.PdPdetail.map(function(detail) {
            return [
                detail.pd_pdetail_id,
                "0"
            ];
        })));
    };
    var valid = selected && selected.PdPdetail.every(function(detail) {
        return integer(amounts[detail.pd_pdetail_id]);
    });
    var save = function() {
        var _ref = _async_to_generator(function() {
            var err;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setSaving(true);
                        setError("");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            5,
                            6
                        ]);
                        return [
                            4,
                            dispatch(addStockCountItem({
                                roundId: roundId,
                                productId: selected.pd_product_id,
                                details: selected.PdPdetail.map(function(detail) {
                                    return {
                                        productDetailId: detail.pd_pdetail_id,
                                        amount: Number(amounts[detail.pd_pdetail_id])
                                    };
                                })
                            })).unwrap()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            onSaved()
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 4:
                        err = _state.sent();
                        setError(stockCountError(err));
                        return [
                            3,
                            6
                        ];
                    case 5:
                        setSaving(false);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function save() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsxs(Modal, {
        className: "stock-count",
        show: true,
        onHide: function() {
            return !saving && onClose();
        },
        size: "xl",
        centered: true,
        backdrop: "static",
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: !saving,
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: selected ? "ระบุจำนวนตรวจนับ" : "เลือกสินค้า"
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Body, {
                children: [
                    error && /*#__PURE__*/ _jsx(Alert, {
                        variant: "danger",
                        children: error
                    }),
                    selected ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "d-flex gap-3",
                                children: [
                                    /*#__PURE__*/ _jsx(ProductImage, {
                                        src: selected.pd_product_image
                                    }),
                                    /*#__PURE__*/ _jsx(ProductName, {
                                        product: selected
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Table, {
                                responsive: true,
                                children: [
                                    /*#__PURE__*/ _jsx("thead", {
                                        children: /*#__PURE__*/ _jsxs("tr", {
                                            children: [
                                                /*#__PURE__*/ _jsx("th", {
                                                    children: "barcode"
                                                }),
                                                /*#__PURE__*/ _jsx("th", {
                                                    children: "ขนาดบรรจุ"
                                                }),
                                                /*#__PURE__*/ _jsx("th", {
                                                    children: "จำนวน"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("tbody", {
                                        children: selected.PdPdetail.map(function(detail) /*#__PURE__*/ {
                                            var _amounts_detail_pd_pdetail_id;
                                            return _jsxs("tr", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("td", {
                                                        children: detail.pd_pdetail_barcode || "-"
                                                    }),
                                                    /*#__PURE__*/ _jsx("td", {
                                                        children: unitLabel(detail, false)
                                                    }),
                                                    /*#__PURE__*/ _jsx("td", {
                                                        children: /*#__PURE__*/ _jsx(Form.Control, {
                                                            className: "form-st-4",
                                                            type: "number",
                                                            min: 0,
                                                            max: 2147483647,
                                                            step: 1,
                                                            "aria-label": "จำนวน ".concat(unitLabel(detail, false)),
                                                            value: (_amounts_detail_pd_pdetail_id = amounts[detail.pd_pdetail_id]) !== null && _amounts_detail_pd_pdetail_id !== void 0 ? _amounts_detail_pd_pdetail_id : "",
                                                            onChange: function(event) {
                                                                return setAmounts(_object_spread_props(_object_spread({}, amounts), _define_property({}, detail.pd_pdetail_id, event.target.value)));
                                                            }
                                                        })
                                                    })
                                                ]
                                            }, detail.pd_pdetail_id);
                                        })
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsxs(Row, {
                                className: "g-3 align-items-end mb-3",
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        md: 6,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "form-st-3",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    children: "ค้นหาสินค้า"
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    className: "form-st-4",
                                                    value: draft.search,
                                                    placeholder: "ชื่อสินค้า / รหัสสินค้า / barcode",
                                                    onChange: function(event) {
                                                        return setDraft(_object_spread_props(_object_spread({}, draft), {
                                                            search: event.target.value
                                                        }));
                                                    }
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        md: 4,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "form-st-3",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    children: "แบรนด์"
                                                }),
                                                /*#__PURE__*/ _jsxs(Form.Select, {
                                                    className: "form-st-4",
                                                    value: draft.brandId,
                                                    onChange: function(event) {
                                                        return setDraft(_object_spread_props(_object_spread({}, draft), {
                                                            brandId: event.target.value
                                                        }));
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ _jsx("option", {
                                                            value: "",
                                                            children: "ทั้งหมด"
                                                        }),
                                                        brands.map(function(brand) {
                                                            return /*#__PURE__*/ _jsx("option", {
                                                                value: brand.set_brand_id,
                                                                children: brand.set_brand_name || brand.set_brand_nameen || "#".concat(brand.set_brand_id)
                                                            }, brand.set_brand_id);
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        md: 2,
                                        children: /*#__PURE__*/ _jsx(Button, {
                                            className: "btn-dg w-100",
                                            disabled: loading,
                                            onClick: function() {
                                                setError("");
                                                setQuery(_object_spread_props(_object_spread({}, query, draft), {
                                                    search: draft.search.trim(),
                                                    page: 1
                                                }));
                                            },
                                            children: "ค้นหา"
                                        })
                                    })
                                ]
                            }),
                            loading ? /*#__PURE__*/ _jsxs("div", {
                                className: "p-3",
                                children: [
                                    /*#__PURE__*/ _jsx(Spinner, {
                                        size: "sm"
                                    }),
                                    " กำลังโหลด..."
                                ]
                            }) : /*#__PURE__*/ _jsxs(Table, {
                                responsive: true,
                                hover: true,
                                children: [
                                    /*#__PURE__*/ _jsx("thead", {
                                        children: /*#__PURE__*/ _jsxs("tr", {
                                            children: [
                                                /*#__PURE__*/ _jsx("th", {
                                                    children: "รูปสินค้า"
                                                }),
                                                /*#__PURE__*/ _jsx("th", {
                                                    children: "ชื่อสินค้า"
                                                }),
                                                /*#__PURE__*/ _jsx("th", {
                                                    children: "barcode / ขนาดบรรจุ"
                                                }),
                                                /*#__PURE__*/ _jsx("th", {
                                                    children: "จัดการ"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("tbody", {
                                        children: rows.length ? rows.map(function(product) {
                                            return /*#__PURE__*/ _jsxs("tr", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("td", {
                                                        children: /*#__PURE__*/ _jsx(ProductImage, {
                                                            src: product.pd_product_image
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("td", {
                                                        children: /*#__PURE__*/ _jsx(ProductName, {
                                                            product: product
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("td", {
                                                        children: product.PdPdetail.map(function(detail) {
                                                            return /*#__PURE__*/ _jsxs("div", {
                                                                className: "stock-count-detail-line",
                                                                children: [
                                                                    detail.pd_pdetail_barcode || "-",
                                                                    " \xb7",
                                                                    " ",
                                                                    unitLabel(detail, false)
                                                                ]
                                                            }, detail.pd_pdetail_id);
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("td", {
                                                        children: /*#__PURE__*/ _jsx(Button, {
                                                            size: "sm",
                                                            className: "btn-dg",
                                                            onClick: function() {
                                                                return select(product);
                                                            },
                                                            children: "เลือก"
                                                        })
                                                    })
                                                ]
                                            }, product.pd_product_id);
                                        }) : /*#__PURE__*/ _jsx("tr", {
                                            children: /*#__PURE__*/ _jsx("td", {
                                                colSpan: 4,
                                                className: "text-center",
                                                children: "ไม่พบสินค้า"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Pager, {
                                paging: paging,
                                page: query.page,
                                pageSize: query.pageSize,
                                loading: loading,
                                onPage: function(page) {
                                    return setQuery(_object_spread_props(_object_spread({}, query), {
                                        page: page
                                    }));
                                },
                                onSize: function(pageSize) {
                                    return setQuery(_object_spread_props(_object_spread({}, query), {
                                        pageSize: pageSize,
                                        page: 1
                                    }));
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    selected && /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        disabled: saving,
                        onClick: function() {
                            return setSelected(null);
                        },
                        children: "กลับไปเลือกสินค้า"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "secondary",
                        disabled: saving,
                        onClick: onClose,
                        children: "ปิด"
                    }),
                    selected && /*#__PURE__*/ _jsx(Button, {
                        className: "btn-dg",
                        disabled: !valid || saving,
                        onClick: save,
                        children: saving ? "กำลังบันทึก..." : "บันทึก"
                    })
                ]
            })
        ]
    });
}
